<tlk-modal-header header>
	{{ isSearchingMatches ? ('PatientSearch.ImportTitle' | translate) : ('PatientSearch.Title' | translate) }}
	<button tlkButton variant="ghost" size="l" right-icon (click)="modalWindowRef.close()">✕</button>
</tlk-modal-header>
<tlk-modal-content content [style.flex]="1" [style.overflow-y]="'auto'" [style.display]="'flex'" [style.flex-direction]="'column'">
	<div class="content-wrapper">
		<div class="search-bar" *ngIf="!isSearchingMatches">
			<tlk-text-input
				class="search-input"
				[(ngModel)]="query"
				(ngModelChange)="onQueryChange()"
				[placeholder]="'PatientSearch.SearchPlaceholder' | translate"
				name="searchQuery">
				<tlk-search-icon tlk-prefix size="20"></tlk-search-icon>
			</tlk-text-input>
			<tlk-select
				class="filter-dropdown"
				[(ngModel)]="systemFilter"
				(ngModelChange)="onFilterChange()"
				[options]="filterOptions"
				[getOptionId]="getFilterId"
				[getOptionName]="getFilterName"
				[placeholder]="'PatientSearch.AllPatients' | translate">
			</tlk-select>
		</div>

		<div class="info-banner" *ngIf="!loading && !isSearchingMatches && isBrowsingRecent && displayedPatients.length > 0">
			<span class="banner-text">{{ 'PatientSearch.BannerText' | translate }}</span>
		</div>

		<div class="results-area">
			<div class="loading-state" *ngIf="loading">
				<rx-delayed-spinner [loading]="loading"></rx-delayed-spinner>
			</div>

			<div class="empty-state" *ngIf="!loading && displayedPatients.length === 0 && isBrowsingRecent">
				<tlk-search-icon size="32"></tlk-search-icon>
				<span>{{ 'PatientSearch.SearchPlaceholder' | translate }}</span>
			</div>

			<div class="empty-state" *ngIf="!loading && displayedPatients.length === 0 && !isBrowsingRecent">
				<span>{{ 'PatientSearch.NoResults' | translate }}</span>
			</div>

			<table class="patient-table" *ngIf="!loading && displayedPatients.length > 0">
		<thead>
			<tr>
				<th></th>
				<th>{{ 'PatientSearch.FullName' | translate }}</th>
				<th>{{ 'PatientSearch.Gender' | translate }}</th>
				<th>{{ 'PatientSearch.DateOfBirth' | translate }}</th>
				<th class="nowrap">{{ 'PatientSearch.ChartNumber' | translate }}</th>
				<th class="nowrap">{{ 'PatientSearch.Platform' | translate }}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let patient of displayedPatients"
				[class.selected]="selectedPatient === patient"
				(click)="selectRow(patient)">
				<td class="avatar-cell">
					<rx-patient-avatar
						[firstName]="patient.firstName"
						[lastName]="patient.lastName"
						[thumbnailUrl]="(patient.invisalignId && thumbnailUrls.get(patient.invisalignId)) || null">
					</rx-patient-avatar>
				</td>
				<td class="name-cell">{{ patient.lastName }}, {{ patient.firstName }}</td>
				<td>{{ patient.gender === 'Male' ? 'M' : 'F' }}</td>
				<td>{{ patient.dateOfBirth | dobFormat }}</td>
				<td>{{ patient.chartNumber }}</td>
				<td class="platform-cell">
					<span *ngIf="patient.system === 'iTero'" tlk-badge backgroundColor="#F2EBFF" textColor="dark" size="m">iTero</span>
					<span *ngIf="patient.system === 'Invisalign'" tlk-badge backgroundColor="#DFF5FC" textColor="dark" size="m">Invisalign</span>
					<span *ngIf="patient.system === 'both'" tlk-badge backgroundColor="#E8F5E8" textColor="dark" size="m">{{ 'PatientSearch.LinkedPatient' | translate }}</span>
				</td>
			</tr>
		</tbody>
	</table>
		</div>
	</div>
</tlk-modal-content>
<tlk-modal-footer footer>
	<ng-container ngProjectAs="[right-buttons]">
		<button tlkButton variant="secondary" size="m" (click)="modalWindowRef.close()">{{ 'PatientSearch.Cancel' | translate }}</button>
		<button tlkButton variant="primary" size="m" [disabled]="!selectedPatient" (click)="confirm()">{{ 'PatientSearch.SelectPatient' | translate }}</button>
	</ng-container>
</tlk-modal-footer>
